import { em } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'

import { ResizeContext } from 'contexts/Resize'
import { Col } from 'styles/components/layout'
import { CartItemTitle } from 'styles/components/typography'

import ToggleHorizontal from 'components/ToggleHorizontal'

import {
  RowStyled,
  Title,
  TitleBlock,
  ToggleBlockText,
  Subtitle,
  TextLHStyled,
  DescBlock,
  CostBlock,
  ToggleBlock,
  ToggleDescription,
  ReadMoreLink,
  DescBlockWrapper,
} from './styles'

const CartItemLayoutNew = props => {
  const {
    title,
    subtitle,
    imageContent,
    descrBlockContent,
    rightBlockContent,
    className,
    alignByCenter,
    dict,
    productType,
    withSubscription,
    isSubscription,
    toggleSubscription,
    toggleModal,
    isDisabled,
  } = props

  const { mobile } = React.useContext(ResizeContext)
  return (
    <div>
      <RowStyled className={className}>
        <Col width={{ xs: em(70), md: em(143), lg: em(192) }} flexShrink="0">
          {imageContent}
        </Col>

        <TitleBlock
          centered={false}
          width={{ xs: `calc(100% - ${em(155)})`, md: 'initial' }}
          flexGrow={{ md: 1 }}
        >
          <Title>
            {typeof title === 'string' ? (
              <>
                <CartItemTitle dangerouslySetInnerHTML={{ __html: title }} />
                {subtitle && subtitle.list ? (
                  <Subtitle>
                    {subtitle.list.map((item, i) => (
                      <TextLHStyled
                        key={i}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </Subtitle>
                ) : null}
              </>
            ) : (
              title
            )}
          </Title>
          <DescBlockWrapper isHidden={isSubscription}>
            {mobile && descrBlockContent}
          </DescBlockWrapper>

          {withSubscription && (
            <ToggleBlock>
              <ToggleHorizontal
                initial={isSubscription}
                isDisabled={isDisabled}
                toggleCb={type =>
                  toggleSubscription &&
                  toggleSubscription({
                    isSubscription: type === 'subscription',
                    productType,
                  })
                }
              />
              <ToggleBlockText>
                <ToggleDescription
                  dangerouslySetInnerHTML={{
                    __html: dict.togglers.subscription.description,
                  }}
                />
                <ReadMoreLink
                  dangerouslySetInnerHTML={{
                    __html: dict.togglers.subscription.read_more,
                  }}
                  onClick={() => toggleModal(true)}
                />
              </ToggleBlockText>
            </ToggleBlock>
          )}
        </TitleBlock>
        <CostBlock
          width={{ xs: em(85), md: em(125), lg: em(197) }}
          order={{ md: 1 }}
          centered={alignByCenter}
          flexShrink="0"
        >
          {rightBlockContent}
        </CostBlock>

        {!mobile && (
          <DescBlock
            width={{ md: em(210), lg: em(289) }}
            order={{ md: 0 }}
            centered={alignByCenter}
            isWideOnMobile={true}
            flexShrink="0"
            isHidden={isSubscription}
          >
            {descrBlockContent}
          </DescBlock>
        )}
      </RowStyled>
    </div>
  )
}

CartItemLayoutNew.propTypes = {
  /** Content of description block (in center on lg) */
  descrBlockContent: PropTypes.node,

  /** Content of right block (in right on lg)*/
  rightBlockContent: PropTypes.node.isRequired,

  /** Title of block */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Vertical align by center flag */
  alignByCenter: PropTypes.bool,

  /** Class name for container */
  className: PropTypes.string,

  /** Object with images */
  imageContent: PropTypes.node,

  /** Label above title */
  label: PropTypes.string,

  /** Subtitle */
  subtitle: PropTypes.object,

  /** Is mobile breakpoint */
  isMobile: PropTypes.bool,

  /** Is mobile breakpoint */
  dict: PropTypes.object,

  productType: PropTypes.string,

  withSubscription: PropTypes.number,

  isSubscription: PropTypes.bool,

  toggleSubscription: PropTypes.func,

  toggleModal: PropTypes.func,

  isDisabled: PropTypes.bool,
}

CartItemLayoutNew.defaultProps = {
  alignByCenter: true,
  className: '',
}

export default CartItemLayoutNew
